import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { SubmissionError } from 'redux-form';
import ContainerDefault from '../../components/ContainerDefault';
import { Loading } from '../../components/UtilComponent';
import * as motoristaAction from '../../services/motorista/Action';
import * as Constants from '../../utils/constants';
import FormMotorista from './components/FormMotorista';

class MotoristaContainer extends Component {

    constructor() {
        super();
        this.handleSave = this.handleSave.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    componentDidMount() {
        if (this.props.match.params.id)
            this.props.action.getMotoristaByIdAction(this.props.match.params.id);
 
    }

    handleCancel(event) {
        event.preventDefault();
        this.props.history.replace(Constants.ROUTE_URL_TRANSPORTADORAS);
    }

    handleSave(values) {       
        
        return this.props.action.saveMotoristaAction(values).then((motoristaObject) => {
            setTimeout(() => {                 
                this.props.history.push(Constants.ROUTE_URL_TRANSPORTADORAS)
            }, 1000)
        }).catch((error) => {
            throw new SubmissionError(error);
        });
        console.log(values);
    }
    
    retornarDadosTela() {
        const { motoristaObject, messages, messageSuccess, isLoading } = this.props;

        if (isLoading) return (
            <Loading title={Constants.DESCRICAO_MOTORISTAS} />
        );

        return (<ContainerDefault
            title={Constants.DESCRICAO_NOVO_MOTORISTA}
            messages={messages}
            messageSuccess={messageSuccess}
            container={
                <FormMotorista                    
                    initialValues={motoristaObject}
                    handleSave={this.handleSave}
                    handleCancel={this.handleCancel}
                    heading={'Adicionar'}
                />
            } />);

    }

    render() {
        return this.retornarDadosTela();
    }
}

const mapStateToProps = state => ({
    motoristaObject: state.motoristaReducer.motoristaObject,
    messages: state.messageResponseReducer.messages,
    messageSuccess: state.messageResponseReducer.messageSuccess,
    isLoading: state.apiReducer.isLoading,

})




const mapDispatchToProps = dispatch => ({
    action: bindActionCreators(motoristaAction, dispatch)
});



export default connect(mapStateToProps, mapDispatchToProps)(MotoristaContainer);